<template>
  <div class="card">
    <h3>Category Name</h3>
    <b-row>
      <b-col md="6">
        English Name
      </b-col>
      <b-col md="6">
        Arabic Name
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col md="6">
        {{ category.name.en }}
      </b-col>
      <b-col md="6">
        {{ category.name.ar }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: { BRow, BCol },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card {
  padding: 12px;
  border: 1px solid #4B6C95;
}
</style>
